import { Group } from "@mantine/core";
import LeftLinks from "./LeftLinks";
import { Outlet } from "react-router-dom";

const ModelsPageWrapper = () => {
  return (
    <Group wrap="nowrap" flex={1} h={"100%"} gap={0} align="start">
      <LeftLinks />

      <Outlet />
    </Group>
  );
};

export default ModelsPageWrapper;
